import { fromJS } from 'immutable';
import { playlist } from 'signoxe/api/schema';
import { assetFromId } from './assets';
import { optionalToJS } from './utils';

export const playlistItemFromId = (state, id) =>
  state.entities.getIn(['playlistItems', id.toString()])
    .update('item', item => assetFromId(state, item));

export const playlistItemsFromIds = (state, ids) =>
  ids.map(id => playlistItemFromId(state, id));

export const playlistFromId = (state, id) => {
  if (state.playlists.ids.includes(id)) {
    return state.entities.getIn(['playlists', id.toString()])
      .update('items', items => playlistItemsFromIds(state, items));
  }
};

export const playlistsFromIds = (state, ids) => ids.map(id => playlistFromId(state, id));
 
export const playlistsAll = (state) => playlistsFromIds(state, state.playlists.ids);

export const updatePlaylistPositionsIM = (playlist) =>
  playlist.update('items', items =>
    items.map((item, idx) =>
      item.update('position', () => idx),
    ),
  );

export const updatePlaylistPositions = (playlist) =>
  updatePlaylistPositionsIM(fromJS(playlist)).toJS();

export const fixPlaylistPositions = (playlist) =>
  updatePlaylistPositionsIM(
    fromJS(playlist).update('items', items => items.sortBy(item => item.get('position'))),
  ).toJS();

export const getPlaylist = (state, id) => optionalToJS(playlistFromId(state, id));

export const getPlaylists = (state) => playlistsAll(state).toJS();

export const getPlaylistPreloadState = (state) => state.paginationState.playlistPage.nextState;
export const isFetchingPlaylist = (state) => state.playlists.isFetching;


// search logic

const ptags = (state) =>
  state.ptags
    .toList()
    .sortBy((tag) => tag.get("count"))
    .reverse();

export const selectedTags = (state) =>
  ptags(state)
    .filter((tag) => tag.get("selected"))
    .map((tag) => tag.get("name"));

export const getTags = (state) => tags(state).toJS();

const playlistHasTags = (playlist, tags) => {
  return tags.isSubset(playlist.get("maintags", []));
};
const playlistMatchesQuery = (playlist, query) =>
  playlist.get("name").toLowerCase().includes(query) ||
  playlist.get("maintags", []).includes(query);


const playlistFilterFunction = (query, tags) => (playlist) =>
  playlistMatchesQuery(playlist, query) &&
  playlistHasTags(playlist, tags);

const filteredPlaylistsByQuery = (state, query) => {
  let filteredPlaylists = playlistsAll(state);
  query = query.trim().toLowerCase();
  const tags = selectedTags(state);


  if (query !== "" || tags.size > 0) {
    filteredPlaylists = filteredPlaylists.filter(
      playlistFilterFunction(query, tags)
    );
  }

  return filteredPlaylists;
};
const filteredPlaylists = (state, query) => {
  return filteredPlaylistsByQuery(state, query);
};
export const getFilteredPlaylists = (state, query) => filteredPlaylists(state, query).toJS();





// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/playlists.js